import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  SimpleForm,
  TextInput,
  Edit,
  Delete,
  Filter,
  ReferenceInput,
  SelectInput,
  EditButton,
  ReferenceField
} from 'admin-on-rest/lib/mui';

import SubGenreInput  from '../custom/SubGenreInput';
import { DependentInput } from 'aor-dependent-input';

const DestinationFilter = (props) => (
  <Filter {...props}>

  <TextInput label="μαρκα / τυπος" source="modelo" alwaysOn/>
  <TextInput label="αριθμος πινακιδας" source="pinakida" alwaysOn/>

  <ReferenceInput label="Εταιρεια" source="CompanyID" reference="companies" allowEmpty alwaysOn perPage={1000}>
  <SelectInput optionText={choice => `${choice.name}`} />
  </ReferenceInput>

  <ReferenceInput label="Υποκαταστημα" source="BranchID" reference="branches" allowEmpty alwaysOn perPage={1000}>
  <SelectInput optionText={choice => `${choice.address}`} />
  </ReferenceInput>

  </Filter>
);

export const OximataList = (props) => (
  <List {...props}  filters={<DestinationFilter />} title="Διαχείριση Όχηματος">
    <Datagrid>
    <TextField label="μαρκα / τυπος" source="modelo"/>
    <TextField label="αριθμος πινακιδας" source="pinakida" />
    <ReferenceField label="Εταιρεια" source="CompanyID" reference="companies">
         <TextField source="name" />
     </ReferenceField>
    <EditButton />
    </Datagrid>
  </List>
);

export const CreateOximata = (props) => (
  <Create title="Δημιουργια οχήματος" {...props}>
    <SimpleForm redirect="list">
    <TextInput label="Μοντέλο" source="modelo"/>
    <TextInput label="Πινακίδα (Γράψτε σε κεφαλαία Λατινικά)" source="pinakida" />

      <ReferenceInput label="Εταιρεια" source="CompanyID" reference="companies" allowEmpty>
      <SelectInput optionText={choice => `${choice.name}`} />
      </ReferenceInput>

       <DependentInput dependsOn="CompanyID" >
       <TextField label="Υποκατάστημα" />
       <SubGenreInput />
      </DependentInput>



    </SimpleForm>
  </Create>
);

const PostTitle = ({ record }) => {
    return <span>{record ? `${record.modelo}` : ''}</span>;
};

export const EditOximata = (props) => (
  <Edit title={<PostTitle />} {...props}>
    <SimpleForm>
    <TextInput label="Μοντέλο" source="modelo"/>
    <TextInput label="Πινακίδα (Γράψτε σε κεφαλαία Λατινικά)" source="pinakida" />
    <ReferenceInput label="Εταιρεια" source="CompanyID" reference="companies" allowEmpty>
    <SelectInput optionText={choice => `${choice.name}`} />
    </ReferenceInput>

    <DependentInput dependsOn="CompanyID" >
    <TextField label="Υποκατάστημα" />
    <SubGenreInput />
   </DependentInput>

    </SimpleForm>
  </Edit>
);

const DeleteTitle = ({ record }) => {
    return <span>{record ? `Διαγραφή του ${record.title}` : ''}</span>;
};

export const DeleteOximata = (props) => <Delete title={<DeleteTitle />} {...props} />;



// WEBPACK FOOTER //
// ./src/pages/companies/oximatas.js